import React from 'react';
import {Tooltip, LineChart, Line, XAxis, YAxis, CartesianGrid, ResponsiveContainer } from 'recharts';



const LineUploads = ({data, colors, title}) =>{




    return(<>
               <h4>{title}</h4>
            <ResponsiveContainer width="100%" height={200}>
              <LineChart data={data}>
                <CartesianGrid strokeDasharray="3 3" />
                <XAxis dataKey="date" />
                <YAxis allowDecimals={false} />
                <Tooltip />
                <Line type="monotone" dataKey="CSVOK" name='Upload CSV' stroke={colors[0]} />
                <Line type="monotone" dataKey="CSVFAIL" name='Tentativa CSV' stroke={colors[1]} />
                <Line type="monotone" dataKey="PDFOK" name='Upload PDF' stroke={colors[2]} />
                <Line type="monotone" dataKey="PDFFAIL" name='Tentativa PDF' stroke={colors[3]} />
              </LineChart>
            </ResponsiveContainer> 
    
    
    </>)
}

export default LineUploads